import type { QueryOptions } from "@tanstack/react-query"
import { type TRPCClient, TRPCClientError } from "@trpc/client"
import { createTRPCReact } from "@trpc/react-query"
import type { AppRouter, TrpcErrorCode } from "../../../api/routes/api/router"

export const trpc = createTRPCReact<AppRouter>()

export type TrpcClient = TRPCClient<AppRouter>

const nonRetryableCodes = new Set<TrpcErrorCode>([
  "BAD_REQUEST",
  "CONFLICT",
  "FORBIDDEN",
  "NOT_FOUND",
  "NOT_IMPLEMENTED",
  "PARSE_ERROR",
  "PAYLOAD_TOO_LARGE",
  "UNAUTHORIZED",
])

export const retryCondition: QueryOptions["retry"] = (failureCount, e) => {
  if (e instanceof TRPCClientError && e.data?.code && nonRetryableCodes.has(e.data.code)) {
    return false
  }

  return failureCount <= 2
}
